import React from 'react'
import styles from './Billing.module.css'
import { FaHome } from 'react-icons/fa';
import adlogo from '../Images/AdManagerLogo.png'
import Billlogo from '../Images/BillingLogo.png'
import Billl from '../Images/arrorwright.png'
import { Link } from "react-router-dom";

const Billing = () => {
    return (
        <>
            <div className={styles.home}>
                <div className={styles.side}>
                    <div>
                        <Link to="/home" className={styles.homeTitle}>
                            <FaHome size={22} className={styles.logo} />
                            <div className={styles.text}>Home</div>
                        </Link>
                        <Link to="/admanager"  className={styles.manager}>
                            <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                            <div className={styles.text}>Ad manager</div>
                            </Link>
                            <Link to="/billing" className={styles.manager1}>
                            <div className={styles.admanag}><img src={Billlogo} alt="" /></div>
                            <div className={styles.text}>Billing</div>
                            </Link>
                    </div>
                    <div className={styles.mail}>
                        <div className={styles.amy}>
                            <div className={styles.hors}>Amy Horsefighter</div>
                            <div className={styles.fighter}>ahorsefighter@gmail.com</div>
                        </div>
                        <img src={Billl} alt="" className={styles.butts} />
                    </div>

                </div>
                <div className={styles.right}>
                    <div className={styles.inner}>
                        <div className={styles.textArea}>
                            <div className={styles.balaHeading}>Your balance</div>
                            <div className={styles.bala}>You’re only able to advrtise by buying $Mads</div>
                        </div>
                        <div className={styles.mad}>
                            <div className={styles.mads}>Mads $0</div>
                            <div className={styles.total}>Total amount</div>
                            <button className={styles.butt}>Make a payment</button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Billing
